module.exports = __webpack_public_path__ + "static/media/CiscoSansTTLight.ee20de28.ttf";